// https://heydon.github.io/Inclusive-Components/cards-redundant-click/script.js

function isRightMB(mouseClickEvent) {
  return mouseClickEvent.which == 3
}

function isMiddleMB(mouseClickEvent) {
  return mouseClickEvent.which == 2
}

export default function A11yBlockLink(node) {
  this.node = node
  this.link = this.node.querySelector('[data-a11y-link]')
}

A11yBlockLink.prototype.init = function () {
  let down, up

  if (this.link) {
    this.node.style.cursor = 'pointer'
    this.node.addEventListener('mouseover', () =>
      this.link.classList.add('active'),
    )
    this.node.addEventListener('mouseout', () =>
      this.link.classList.remove('active'),
    )
    this.node.addEventListener('mousedown', () => (down = +new Date()))
    this.node.addEventListener('mouseup', (e) => {
      const isLink = e.target.tagName == 'A'
      const isButton = e.target.tagName == 'BUTTON'
      const isLinkChild = e.target.closest('[data-a11y-link]')

      if (isLink || isButton || isLinkChild) return
      if (isRightMB(e)) return

      up = +new Date()
      if (up - down < 200) {
        const ctrlKey = isMiddleMB(e) ? true : e.ctrlKey
        this.link.dispatchEvent(new MouseEvent('click', { ctrlKey }))
      }
    })
  }
}
